import AppShell from "@/components/feature/AppShell";

export default function Placeholder({ title, desc }: { title: string; desc: string }) {
  return (
    <AppShell>
      <header className="px-5 pt-6 pb-4">
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        <p className="text-xs text-gray-400 mt-1">{desc}</p>
      </header>
      <div className="px-5 mt-10 flex flex-col items-center justify-center text-center">
        <span className="w-16 h-16 rounded-full bg-mint-50 flex items-center justify-center text-mint-500">
          <i className="ri-tools-line text-2xl"></i>
        </span>
        <p className="mt-4 text-sm text-gray-500">这个页面正在规划中，稍后就会上线～</p>
      </div>
    </AppShell>
  );
}